module.exports = __webpack_public_path__ + "static/masks-desktop-cebdfcc2574a0c6c826475baceae5ddc.png";